import { Input } from "../../ui/input";

interface MeetingDateTimeProps {
  createdAt: string | null;
  onDateChange: (date: string) => void;
}

export function MeetingDateTime({ createdAt, onDateChange }: MeetingDateTimeProps) {
  return (
    <div className="relative flex w-[185px] items-center">
      <Input
        type="datetime-local"
        value={createdAt ? new Date(createdAt).toISOString().slice(0, 16) : ""}
        onChange={(e) => onDateChange(e.target.value)}
        className="h-7 pl-2 py-1 border-gray-300 text-sm text-gray-500"
      />
    </div>
  );
}